"use client";

import { useState, useEffect, useMemo } from "react";
import isBrowser from "../helpers/isBrowser";

export default function useWindowSize() {
  function getSize() {
    if (!isBrowser()) {
      return { width: 0, height: 0, belowInspectorThreshold: false };
    }
    return {
      width: window.innerWidth,
      height: window.innerHeight,

      // Custom screen size metric bools
      belowInspectorThreshold: window.innerWidth <= 1200,
      isMobile: window.innerWidth <= 768,
    };
  }

  const [windowSize, setWindowSize] = useState(getSize);

  useEffect(() => {
    function handleResize() {
      setWindowSize(getSize());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return useMemo(() => windowSize, [windowSize]);
}
